import { all, takeLatest, fork } from 'redux-saga/effects';

import {
    USER_GET_REQUEST,
    USER_UPDATE_REQUEST,
    USER_PROFILE_UPDATE_REQUEST,
    USER_CHANGE_PASSWORD_REQUEST,
    USER_SEND_LOST_PASSWORD_REQUEST,
    USER_RESET_PASSWORD_REQUEST,
    GET_MOBILITY_PLANS,
    USER_SUBSCRIBE_TO_A_PLAN,
    USER_UNSUBSCRIBE_FROM_A_PLAN,
    USER_GET_PAYMENT_DETAILS,
    USER_REQUEST_ACCOUNT_DELETION,
    USER_GET_PROFILE_SERVICES_WITH_STATUS,
    AGREE_TO_TERMS_OF_USE_REQUEST,
    SETUP_MOBILITY_PLAN_PAGE,
    USER_SWITCH_PLAN,
    USER_GET_ONGOING_TRIPS,
} from '../../redux/user/types';

import get from './get';
import update from './update';
import updateProfile from './updateProfile';
import changePassword from './changePassword';
import sendLostPassword from './sendLostPassword';
import resetPassword from './resetPassword';
import uploadDocumentAttachement from './uploadDocumentAttachement';
import saveDocumentForm from './saveDocumentForm';
import getMobilityPlansSaga from './mobilityPlans.saga';
import subscribeToAPlan from './subscribeToAPlan';
import unsubscribeFromAPlan from './unsubscribeFromAPlan';
import getPaymentDetails from './getPayment';
import requestAccountDeletion from './requestAccountDeletion';
import getUserServicesStatus from './getUserServicesStatus';
import agreeToCityTerms from './agreeToCityTerms';
import setupMobilityPlanPageSaga from './setupMobilityPlanPage.saga';
import switchPlan from './switchPlan';
import { getOngoingTripsSaga } from './getOngoingTrips';

export default function*() {
    yield all([
        takeLatest(USER_GET_REQUEST, get),
        takeLatest(USER_UPDATE_REQUEST, update),
        takeLatest(USER_PROFILE_UPDATE_REQUEST, updateProfile),
        takeLatest(USER_CHANGE_PASSWORD_REQUEST, changePassword),
        takeLatest(USER_SEND_LOST_PASSWORD_REQUEST, sendLostPassword),
        takeLatest(USER_RESET_PASSWORD_REQUEST, resetPassword),
        takeLatest(GET_MOBILITY_PLANS, getMobilityPlansSaga),
        takeLatest(SETUP_MOBILITY_PLAN_PAGE, setupMobilityPlanPageSaga),
        takeLatest(USER_SUBSCRIBE_TO_A_PLAN, subscribeToAPlan),
        takeLatest(USER_SWITCH_PLAN, switchPlan),
        takeLatest(USER_UNSUBSCRIBE_FROM_A_PLAN, unsubscribeFromAPlan),
        takeLatest(USER_GET_PAYMENT_DETAILS, getPaymentDetails),
        takeLatest(USER_REQUEST_ACCOUNT_DELETION, requestAccountDeletion),
        takeLatest(USER_GET_PROFILE_SERVICES_WITH_STATUS, getUserServicesStatus),
        takeLatest(AGREE_TO_TERMS_OF_USE_REQUEST, agreeToCityTerms),
        fork(uploadDocumentAttachement),
        fork(saveDocumentForm),
        takeLatest(USER_GET_ONGOING_TRIPS, getOngoingTripsSaga),
    ]);
}
